import PhotoUpload from '@/components/upload-image'
export default {
  name: 'edit',
  components: {PhotoUpload},
  props: [],
  data () {
    return {
      user: {
        gender: '',
        post_code: '',
        avatar: '',
        fullname: '',
        extendinfo: ''
      },
      errors: {},
      btn_reset: false,
      btn_create: false,
      accept: 'image/*',
      avatar: ''
    }
  },
  computed: {
    positions () {
      return this.$store.getters['Position/getListPosition']
    }
  },
  mounted () {
    this.btn_reset = true
    this.btn_create = true
    this.$loading.start()
    Promise.all([
      this.$store.dispatch('Profile/getProfile'),
      this.$store.dispatch('Position/getListPosition', {page: 1, per_page: 'all', status: 1})
    ]).then(res => {
      this.btn_reset = false
      this.btn_create = false
      this.$loading.complete()
      this.user = res[0]
      this.user.post_code = res[0].position
    }).catch(errors => {
      this.btn_reset = false
      this.btn_create = false
      this.$loading.fail()
    })
  },
  methods: {
    fileChange (file) {
      this.avatar = file
    },
    update () {
      const fd = new FormData()
      fd.append('id', this.user.id)
      fd.append('avatar', this.avatar)
      fd.append('name', this.user.fullname)
      fd.append('gender', this.user.gender)
      fd.append('info', this.user.extendinfo==null?'':this.user.extendinfo)

      this.$loading.start()
      this.btn_reset = true
      this.btn_create = true
      this.$store.dispatch('Profile/updateProfile', {user: fd}).then(res => {
        this.$loading.complete()
        this.btn_reset = false
        this.btn_create = false
        this.$router.push('/profile')
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.update_success')
        })
      }).catch(errors => {
        if (errors.status === 422) {
          this.errors = errors.data.error
        }
        this.btn_reset = false
        this.btn_create = false
        this.$loading.fail()
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/profile/edit/edit.js